import { render } from "./CreateCustomTest.vue?vue&type=template&id=13dfbc82&scoped=true"
import script from "./CreateCustomTest.vue?vue&type=script&lang=js"
export * from "./CreateCustomTest.vue?vue&type=script&lang=js"

import "./CreateCustomTest.vue?vue&type=style&index=0&id=13dfbc82&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13dfbc82"]])

export default __exports__